// Buffer for drawings before removing the oldest ones (in KB)
export const CHART_CONTENT_SIZE_BUFFER_IN_KB = 150;
export const TOTAL_ALLOWED_LAYOUTS = 20;
